import { Card, CardContent, CardMedia, CardActions, Typography } from '@mui/material';
import dayjs from 'dayjs';
import newsPlaceholder from '../../assets/news_placeholder.png';

export interface INoticiaCard {
  noticia: any;
}

const NoticiaCardFixed: React.FC<INoticiaCard> = ({ noticia }) => {
  return (
    <Card
      key={noticia.id}
      sx={{
        width: '100%',
        height: '100%', // Para ocupar todo o espaço disponível
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        transition: 'transform 0.3s ease',
        '&:hover': {
          transform: 'translateY(-5px)',
          boxShadow: '0 6px 12px rgba(0,0,0,0.15)'
        },
        cursor: 'pointer',
        borderRadius: '8px',
        border: '1px solid #e9eaeb'
      }}
      onClick={() => noticia.link && window.open(noticia.link, '_blank')}
    >
      <CardMedia
        component="img"
        height="180"
        image={noticia.imagem || newsPlaceholder}
        alt={noticia.titulo || 'Notícia'}
        sx={{ objectFit: 'cover', flexShrink: 0 }}
      />
      <CardContent sx={{ 
        flexGrow: 1, // Isso faz com que este elemento se expanda para preencher o espaço
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      }}>
        <Typography 
          variant="h6" 
          component="div" 
          sx={{ 
            fontWeight: 'bold', 
            fontSize: '1rem', 
            lineHeight: 1.3,
            // Limitar a quantidade de linhas de texto para manter altura consistente
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            mb: 1
          }}
        >
          {noticia.titulo}
        </Typography>
      </CardContent>
      {
        noticia.dataPublicacao && (
          <CardActions sx={{
            borderTop: '1px solid rgba(0,0,0,0.1)',
            padding: '8px 16px',
            justifyContent: 'flex-start',
            flexShrink: 0,
            marginTop: 'auto'
          }}>
            <Typography variant="caption" color="text.secondary">
              {noticia.categoria || ''} {noticia.categoria && noticia.dataPublicacao ? '- ' : ''} 
              {noticia.dataPublicacao ? dayjs(noticia.dataPublicacao).format('DD/MM/YYYY') : ''}
            </Typography>
          </CardActions>
        )
      }
    </Card>
  );
};

export default NoticiaCardFixed;
